"use client";

import useLoginStore from "@/src/store/useLoginStore";
import useUserStore from "@/src/store/useUser";
import { UserCircle } from "lucide-react";
import Link from "next/link";

const ProfileHeader = () => {
    const { openLogin } = useLoginStore()
    const { dataUser } = useUserStore()
    return (
        <Link href={!dataUser?.token ? "#" : "/profile"} onClick={() => {
            if (!dataUser?.token) {
                openLogin()
            }
        }} className="h-8 w-8 flex items-center justify-center rounded p-1">
            <UserCircle />
        </Link>
    );
};

export default ProfileHeader;
